export function getFieldError<K extends string | number | symbol>(
  errors: Record<string, Array<string>>,
  fieldName: K,
): string | undefined {
  return errors[fieldName as string]?.[0]
}

export function getFieldValue<K extends string | number | symbol>(
  inputs: Record<string, unknown> | undefined,
  fieldName: K,
): string {
  const value = inputs?.[fieldName as string]
  return typeof value === 'string' ? value : ''
}
